import { render, staticRenderFns } from "./JgpMenuItem.vue?vue&type=template&id=c7155936&"
import script from "./JgpMenuItem.vue?vue&type=script&lang=js&"
export * from "./JgpMenuItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports